"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EotcBuySellDesktopLayout", {
  enumerable: true,
  get: function get() {
    return _EotcBuySellDesktopLayout["default"];
  }
});
Object.defineProperty(exports, "EotcBuySellMobileLayout", {
  enumerable: true,
  get: function get() {
    return _EotcBuySellMobileLayout["default"];
  }
});
Object.defineProperty(exports, "EotcBuySellTabletsLayout", {
  enumerable: true,
  get: function get() {
    return _EotcBuySellTabletsLayout["default"];
  }
});
var _EotcBuySellDesktopLayout = _interopRequireDefault(require("./EotcBuySellDesktopLayout"));
var _EotcBuySellTabletsLayout = _interopRequireDefault(require("./EotcBuySellTabletsLayout"));
var _EotcBuySellMobileLayout = _interopRequireDefault(require("./EotcBuySellMobileLayout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }